export class OrganizationsAdminApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
async function call(baseUrl, path = '', init) {
    const response = await fetch(baseUrl.replace(/\/$/, '') + '/identity/organizations' + path, {
        credentials: 'include',
        ...init,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...init?.headers },
    });
    const body = await response.json().catch(() => null);
    if (!response.ok)
        throw new OrganizationsAdminApiError(response.status, typeof body?.message === 'string' ? body.message : 'No se pudo completar la operación.');
    return body;
}
export const getAdminOrganizations = (baseUrl, signal) => call(baseUrl, '', signal ? { signal } : undefined);
export const createAdminOrganization = (baseUrl, input, operationId) => call(baseUrl, '', {
    method: 'POST',
    headers: { 'x-urbanik-operation-id': operationId },
    body: JSON.stringify(input),
});
export const updateOrganizationCapacity = (baseUrl, organizationId, slotCapacity) => call(baseUrl, '/' + encodeURIComponent(organizationId) + '/capacity', { method: 'PUT', body: JSON.stringify({ slotCapacity }) });
export const updateOrganizationStatus = (baseUrl, organizationId, operationalEnabled) => call(baseUrl, '/' + encodeURIComponent(organizationId) + '/status', { method: 'PUT', body: JSON.stringify({ operationalEnabled }) });
export const deleteAdminOrganization = (baseUrl, organizationId) => call(baseUrl, '/' + encodeURIComponent(organizationId), {
    method: 'DELETE',
    body: JSON.stringify({}),
});
